/* eslint-disable max-depth */
import React from "react";
import ImageCarousel from "web/react/components/image-carousel/image-carousel";
import { gettext } from "web/script/modules/django-i18n";
import { RawBranchLink } from "web/script/utils/branch-io";
import styles from "./app-benefits-feed-item.css";
import appIcon from "./images/icon-large.png";

export function AppBenefitsFeedItem(): JSX.Element {
    const branchLink = RawBranchLink.InFeedBenefits;

    const sliderContent = [
        {
            // "Lyst is even better in the App"
            title: gettext("feed.in_feed_banner.title_1"),
            // "Swipe for a sneak peek"
            desc: gettext("feed.in_feed_banner.description_1"),
            image: appIcon,
        },
        {
            // "Skip endless scrolling"
            title: gettext("feed.in_feed_banner.title_2"),
            // "Shop more brands and stores than anywhere else"
            desc: gettext("feed.in_feed_banner.description_2"),
            image: appIcon,
        },
        {
            // "Express your style"
            title: gettext("feed.in_feed_banner.title_3"),
            // "Discover new items tailored to your style"
            desc: gettext("feed.in_feed_banner.description_3"),
            image: appIcon,
        },
        {
            // "Never miss out"
            title: gettext("feed.in_feed_banner.title_4"),
            // "Sales notifications and personalised recommendations"
            desc: gettext("feed.in_feed_banner.description_4"),
            image: appIcon,
        },
    ];

    function benefitItem(itemContent): JSX.Element {
        const { title, desc, image } = itemContent;
        return (
            <>
                <div className={styles.iconContainer}>
                    <img src={image} className={styles.icon} alt="Lyst app" />
                </div>
                <div className={styles.textContainer}>
                    <span className={styles.benefitTitle}>{title}</span>
                    <span className={styles.benefitDescription}>{desc}</span>
                </div>
            </>
        );
    }
    const benefitItems: JSX.Element[] = [];
    for (let i = 0; i < sliderContent.length; ++i) {
        benefitItems.push(benefitItem(sliderContent[i]));
    }

    return (
        <div className={styles.carouselContainer}>
            <ImageCarousel branchLink={branchLink} carouselItems={benefitItems} showDots={true} />
        </div>
    );
}
export default AppBenefitsFeedItem;
